module.exports = __webpack_public_path__ + "static/media/9.3073bc4d.jpg";